import React, { useEffect, useState } from 'react'
import { useFormSteps } from '../../formStepsContext'

function Roommates(props) {
  const { setCanGoNext, setCanGoBack, currentPage, data, setData } = useFormSteps();
  const { page } = props;

  const initialRoommateDetails = [
    {
      id: 'male',
      label: 'Male',
      value: data.host.roommates.male,
      // value: 0,
    },
    {
      id: 'female',
      label: 'Female',
      value: data.host.roommates.female,
      // value: 0,
    },
    {
      id: 'nonbinary',
      label: 'Non-binary',
      value: data.host.roommates.nonbinary,
      // value: 0,
    },
  ];

  const [roommateDetails, setRoommateDetails] = useState(initialRoommateDetails);

  // If fetched from firestore, update it
  useEffect(() => {
    if (data.host.roommates) {
      console.log("Found rommates in host");
      setRoommateDetails(initialRoommateDetails);
    }
  }, [data]);

  // Re-enable buttons on component mount
  useEffect(() => {
    if (currentPage == page) {
      setCanGoBack(true);
      setCanGoNext(true);
    }
  }, []);

  // Update form data
  const updateData = (updatedRoommateDetails) => {
    const newRoommateCounts = updatedRoommateDetails.reduce((acc, item) => {
      return { ...acc, [item.id]: item.value };
    }, {});

    setData({
      ...data,
      host: {
        ...data.host,
        roommates: newRoommateCounts,
      },
    });
  };

  // Add 1 to value if + or subtract 1 to value if -
  const handleOperation = (id, operation) => {
    const updatedRoommateDetails = roommateDetails.map(item => {
      if (item.id === id) {
        let newValue = operation === '+' ? item.value + 1 : item.value - 1;
        newValue = newValue < 0 ? 0 : newValue;
        return { ...item, value: newValue };
      }
      return item;
    });
    setRoommateDetails(updatedRoommateDetails);
    updateData(updatedRoommateDetails);
  };

  // Render buttons
  const OperationButton = ({ id, operation }) => {
    return (
      <>
        <button
          className='rounded-full w-8 h-8 border border-hostU-blue-400'
          onClick={() => handleOperation(id, operation)}
        >
          <p className='pointer-events-none -translate-y-[1px]'>{operation}</p>
        </button>
      </>
    )
  }

  return (
    <>
      <div className='w-screen h-screen flex flex-col items-center sm:justify-center justify-start pt-[80px] sm:pt-0 pb-[700px] sm:pb-0'>
        <div className='w-full sm:w-[600px] pt-10 px-5 sm:px-0'>
          <div className='w-full text-left py-0'>
            <h2 className='text-[2rem] my-0 py-2 leading-tight font-medium'>Will there be other individuals in your place during your guest's stay?</h2>
            <p className='opacity-50 pb-3'>If so, please disclose their genders for the guest's convenience and comfort</p>
          </div>
          <div className='w-full flex flex-col text-xl'>
            {roommateDetails.map(item => (
              <div key={item.id} className='flex flex-row justify-between py-10 border-b border-black border-opacity-10 w-full items-center'>
                <p>{item.label}</p>
                <div className='flex flex-row gap-2 items-center'>
                  <OperationButton
                    id={item.id}
                    operation="-"
                  />
                  <p className='w-8 text-center'>{item.value}</p>
                  <OperationButton
                    id={item.id}
                    operation="+"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Roommates
